import React, { Component } from 'react';
import { connect } from 'react-redux';
import './MobileSpinner.scss';
import mobileBridge from '../../helpers/MobileBridge';

export class MobileSpinner extends Component {

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
  }

  render() {
    let classes;
    return (

      <div className={`splash-screen ${classes}` }>
        <div id="mobile-loader-spinner"></div>
      </div>
    );
  }
}

export default connect(null, null)(MobileSpinner);



// WEBPACK FOOTER //
// ./src/components/MobileSpinner/index.js